import React from "react";
import { Logo } from "./Logo";

export const FinalCTA = () => (
  <footer className="relative border-t border-white/10 bg-navy-950 text-white" data-testid="footer-section">
    <div className="relative mx-auto max-w-7xl px-6 py-14 md:px-12 md:py-16">
      <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1 space-y-4">
          <Logo />
          <p className="max-w-xs text-xs text-white/60 font-medium leading-relaxed">
            ERP + CRM + PDV + Ponto Digital + Contabilidade com Talos — a IA especialista que opera o sistema com você.
          </p>
        </div>
        <div>
          <p className="mb-4 text-xs font-bold uppercase tracking-widest text-white/40">
            Plataforma
          </p>
          <ul className="space-y-2.5 text-xs font-medium text-white/70">
            <li><a href="#modulos" className="transition-colors hover:text-white">Módulos</a></li>
            <li><a href="#talos" className="transition-colors hover:text-white">Talos · IA</a></li>
            <li><a href="#ia-embutida" className="transition-colors hover:text-white">IA nos fluxos</a></li>
            <li><a href="#showcase" className="transition-colors hover:text-white">Telas do App</a></li>
          </ul>
        </div>
        <div>
          <p className="mb-4 text-xs font-bold uppercase tracking-widest text-white/40">
            Empresa
          </p>
          <ul className="space-y-2.5 text-xs font-medium text-white/70">
            <li><a href="#diferenciais" className="transition-colors hover:text-white">Diferenciais</a></li>
            <li><a href="#planos" className="transition-colors hover:text-white">Planos</a></li>
            <li><a href="#faq" className="transition-colors hover:text-white">Dúvidas frequentes</a></li>
          </ul>
        </div>
        <div>
          <p className="mb-4 text-xs font-bold uppercase tracking-widest text-white/40">
            Legal & Segurança
          </p>
          <ul className="space-y-2.5 text-xs font-medium text-white/70">
            <li><a href="#" className="transition-colors hover:text-white">Privacidade de Dados</a></li>
            <li><a href="#" className="transition-colors hover:text-white">Termos de Uso</a></li>
            <li><a href="#" className="transition-colors hover:text-white">Portaria 671 MTP</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row">
        <p>MUFT Tecnologia · Gestão All-in-One com IA</p>
        <p>© {new Date().getFullYear()} MUFT. Todos os direitos reservados.</p>
      </div>
    </div>
  </footer>
);

export default FinalCTA;
